import React from 'react';
import styled from 'styled-components';
import { TableFilters, BelongsToFilterSelects } from '../../design-system';
import { FiltersSetStatesProp } from '../../types';

const TableFiltersBase = styled(TableFilters)`
  & > *:nth-child(4) {
    order: 1;
  }
  & > *:nth-child(1) {
    order: 2;
  }
  & > *:nth-child(2) {
    order: 3;
  }
  & > *:nth-child(3) {
    order: 4;
  }
`;

interface Props {
  setStates: FiltersSetStatesProp;
}

export const Filters: React.FC<Props> = ({ setStates }: Props) => {
  return (
    <TableFiltersBase>
      <BelongsToFilterSelects
        handleChange={(obj) => {
          setStates('force', obj);
        }}
      />
    </TableFiltersBase>
  );
};
